import { Button, Card, CardBody, Typography } from "@material-tailwind/react";
import React from "react";

const ReportDelivery = () => {
  const lang = localStorage.getItem("language");
  return (
    <div className="px-0 lg:px-2 mt-2">
      <div>
        <Card className="rounded-sm w-full">
          {" "}
          <Typography className="text-red-600 text-2xl font-semibold p-2 rounded-none">
            {lang === "en" ? "Report Delivery" : "রিপোর্ট ডেলিভারী"}
          </Typography>
        </Card>
      </div>
      <hr className="my-3" />

      <Card className="bg-red-50 rounded-sm">
        <CardBody className="flex justify-center items-center">
          <a
            target="_blank"
            href="http://103.230.62.205:9091/medicare-web-client-v2/#/login"
          >
            <Button
              color="green"
              className="bg-green-500 rounded-sm normal-case tracking-widest"
            >
              {lang === "en"
                ? "Click to get report"
                : "রিপোর্ট পেতে এখানে ক্লিক করুন"}
            </Button>
          </a>
        </CardBody>
      </Card>
    </div>
  );
};

export default ReportDelivery;
